module.exports = __webpack_public_path__ + "img/LOGISTICA.1fd6a753.png";